/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'bookmark': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: `<path d="M14,0 L2,0 C0.897,0 0,0.897 0,2 L0,21 C0,21.403 0.244,21.769 0.619,21.925 C0.994,22.081 1.422,21.994 1.71,21.709 L8.001,15.415 L14.295,21.709 C14.486,21.9 14.742,22.003 15.001,22.003 C15.129,22.003 15.26,21.978 15.382,21.928 C15.757,21.772 16.001,21.409 16.001,21.003 L16.001,2 C16.001,0.897 15.104,0 14.001,0 L14,0 Z M14,18.584 L8.706,13.293 C8.512,13.099 8.256,12.999 8,12.999 C7.744,12.999 7.487,13.096 7.294,13.293 L2,18.584 L2,2 L14,2 L14,18.584 Z" id="Shape"/>`
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/bookmark.js